module.exports = __webpack_public_path__ + "assets/img/gar1-2.2f1b5317.jpg";